'use client';

import './styles/@theme';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { Spinner } from '@/app/elements/spinner';

export const FullscreenSkeleton = () => {
    return (
        <div className="fullscreen-skeleton">
            <div className="fullscreen-header">
                <span className="back-button" />
                <span className="title" />
                <span className="sound-button" />
            </div>
            <div className="fullscreen-content">
                <Spinner />
            </div>
            <div className="fullscreen-info">
                <div className="info-top">
                    <span className="logo" />
                    <div className="text-content">
                        <span className="game-name" />
                        <span className="game-description" />
                    </div>
                </div>
                <div className="info-bottom">
                    <span className="info-button" />
                    <span className="play-button" />
                </div>
            </div>
        </div>
    );
};
